import helper from 'util/helpers';
import eventBus from '@/EventBus';
import eventType from '@/components/operation/enums/eventType';
import messageUtil from 'util/messages';
import moment from 'moment';
import Vue from 'vue';

const getDefaultState = () => {
  return {
    displayingChatRoomId: -1,
    displayingChatRoomStatus: 'ACTIVE',
    tabChatRooms: [], // 중앙 챗룸 탭
    allChatRooms: [], // 전체
    waitChatRooms: [], // 대기 (미사용?)
    assignChatRooms: [], // 할당
    activeChatRooms: [], // 상담중
    holdChatRooms: [], // 보류
    summaryChatRooms: [], // 후처리
    completedChatRooms: [], // 완료
    transferredChatRooms: [], // 이관
    selectedRoomStatus: ['ASSIGN', 'ACTIVE', 'WAITING', 'SUMMARY_WAITING', 'COMPLETED', 'TAKE_OVER_ROOM'],
    selectedTabStatus: 'ACTIVE', // 현재 선택중인 탭
    markedChatRoom: '',
    tagList: [],
    alarmedChatRoomId: '',
    isSearchAllChatRoomMode: false,
    lastMessages: {},
    waitCount: 0,
    isTyping: false, // 어바웃펫 입력 감지 커스텀
    isFaqActive: false,
    arrFaqList: [],
    maxFaqList: false,
    isMsgContext: false,
    lastMessage: {}
  };
};
const state = getDefaultState();

const getters = {
  displayingChatRoomId: (state) => {
    return state.displayingChatRoomId;
  },
  displayingChatRoomStatus: (state) => {
    return state.displayingChatRoomStatus;
  },
  isChatRoomInTabChatRooms: (state) => {
    return (chatRoomId) => {
      return helper.isObjectValid(helper.findByChatRoomId(state.tabChatRooms, chatRoomId));
    };
  },
  chatRoomTabList: (state) => {
    return state.tabChatRooms;
  },
  selectedRoomStatus: (state) => {
    return state.selectedRoomStatus;
  },
  selectedTabStatus: (state) => {
    return state.selectedTabStatus;
  },
  waitChatRoomList: (state) => {
    return state.waitChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  assignChatRoomList: (state) => {
    return state.assignChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  activeChatRoomList: (state) => {
    return state.activeChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  completeChatRoomList: (state) => {
    return state.completedChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  summaryChatRoomList: (state) => {
    return state.summaryChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  holdChatRoomList: (state) => {
    return state.holdChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  transferredChatRoomList: (state) => {
    return state.transferredChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  allChatRoomList: (state) => {
    return state.allChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId);
  },
  allChatRoomListOrderByCreateDate: (state) => {
    return state.allChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  // operation_left 에서 정렬을 생성순 -> 상담 연결순으로 변경
  waitChatRoomListOrderByCreateDate: (state) => {
    return state.waitChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  assignChatRoomListOrderByCreateDate: (state) => {
    return state.assignChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  activeChatRoomListOrderByCreateDate: (state) => {
    return state.activeChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  holdChatRoomListOrderByCreateDate: (state) => {
    return state.holdChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  summaryChatRoomListOrderByCreateDate: (state) => {
    return state.summaryChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  completeChatRoomListOrderByCreateDate: (state) => {
    return state.completedChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  transferredChatRoomListOrderByCreateDate: (state) => {
    return state.transferredChatRooms.sort((left, right) => moment(right.createDate) - moment(left.createDate));
  },
  markedChatRoom: (state) => {
    return state.markedChatRoom;
  },
  tagList: (state) => {
    return state.tagList;
  },
  alarmedChatRoomId: (state) => {
    return state.alarmedChatRoomId;
  },
  isSearchAllChatRoomMode: (state) => {
    return state.isSearchAllChatRoomMode;
  },
  getLastMessages(state) {
    return state.lastMessages;
  },
  getWaitCount: (state) => {
    return state.waitCount;
  },
  getTyping: (state) => {
    return state.isTyping; // 어바웃펫 입력 감지 커스텀
  },
  getIsFaqActive: (state) => {
    return state.isFaqActive; // FAQ 검색 커스텀
  },
  getArrFaqList: (state) => {
    return state.arrFaqList;
  },
  getIsFaqMaxList: (state) => {
    return state.maxFaqList;
  },
  getIsMsgContext: (state) => {
    return state.isMsgContext;
  },
  getLastMessage(state) {
    return state.lastMessage;
  }
};

const mutations = {
  changeSelectedStatus(state, statuses) {
    state.selectedRoomStatus = statuses;
  },
  changeSelectedTabStatus(state, statuses) {
    state.selectedTabStatus = statuses;
  },
  changeDisplayingChatRoomId(state, { chatRoomId, callback }) {
    state.displayingChatRoomId = chatRoomId;
    callback();
  },
  changeDisplayingChatRoomStatus(state, status) {
    state.displayingChatRoomStatus = status;
  },
  setLastMessages(state, data) {
    try {
      let moduleChannelName = data.moduleChannel ? data.moduleChannel.channelName.code : '';
      if (moduleChannelName === 'MAIL') {
        state.lastMessages[data.chatRoomId] = {
          message: '',
          date: moment(`${data.createDate}`, 'YYYYMMDDHHmmss Z').format('MM-DD'),
          timeDiff: moment(moment(`${data.createDate}`, 'YYYYMMDDHHmmss Z').format('YYYY-MM-DD HH:mm')).fromNow(),
          onlyTime: moment(`${data.createDate}`, 'YYYYMMDDHHmmss Z').format('HH:mm')
        };
      } else {
        let showMessage = '';
        let contentType = JSON.parse(data.lastMessageInfo.content);
        switch (data.lastMessageInfo.messageType || 'TEXT') {
          case 'TEXT':
          case 'START':
          case 'END':
          case 'HOLD':
          case 'ACTIVE':
          case 'ASSIGN':
          case 'BROWSER_EXIT':
          case 'SURVEY':
          case 'TAKE_OVER':
          case 'AUTO_CLOSE':
          case 'COMBINATION':
            showMessage += contentType.text;
            break;
          case 'PHOTO':
            showMessage += '<<사진>>';
            break;
          case 'VIDEO':
            showMessage += '<<영상>>';
            break;
          case 'FILE':
            showMessage += '<<파일>>';
            break;
        }
        let brandBanWordInfo = messageUtil.getBanWords().filter((info) => info.brandId === data.brand.id);
        state.lastMessages[data.chatRoomId] = {
          message: brandBanWordInfo[0] ? messageUtil.replaceBanWordToStar(brandBanWordInfo[0].banWords, showMessage) : showMessage,
          date: moment(`${data.lastMessageInfo.createDate}`, 'YYYYMMDDHHmmss Z').format('MM-DD'),
          timeDiff: moment(moment(`${data.lastMessageInfo.createDate}`, 'YYYYMMDDHHmmss Z').format('YYYY-MM-DD HH:mm')).fromNow(),
          onlyTime: moment(`${data.lastMessageInfo.createDate}`, 'YYYYMMDDHHmmss Z').format('HH:mm'),
          senderType: data.lastMessageInfo.senderType,
          createDate: data.lastMessageInfo.createDate,
          messageId: data.lastMessageInfo.id
        };
        state.lastMessages = { ...state.lastMessages };
      }
    } catch (e) {
      console.log(e);
    }
  },
  setLastMessage(state, data) {
    state.lastMessage = { ...state.lastMessage, [data.chatRoomId]: data };
  },
  setNewMessageFlagToWaitChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.waitChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = true;
    }
  },
  setNewMessageFlagToAssignChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.assignChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = true;
    }
  },
  setNewMessageFlagToActiveChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.activeChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = true;
    }
  },
  setNewMessageFlagToTransferChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.transferredChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = true;
    }
  },
  deleteNewMessageFlagToAssignChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.assignChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = false;
    }
  },
  deleteNewMessageFlagToActiveChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.activeChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = false;
    }
  },
  deleteNewMessageFlagToTransferChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.transferredChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = false;
    }
  },
  setNewMessageFlagToTabChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.tabChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom) && chatRoom.status !== 'ALL') {
      chatRoom.isNewMessage = true;
    }
  },
  deleteNewMessageFlagToTabChatRoomList(state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.tabChatRooms, chatRoomId);
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.isNewMessage = false;
    }
  },
  addTabChatRoom(state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.tabChatRooms, chatRoom.chatRoomId);
    if (findChatRoom !== undefined && findChatRoom.status !== chatRoom.status) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1);
      state.tabChatRooms.push(chatRoom);
    } else if (!helper.isObjectValid(findChatRoom)) {
      state.tabChatRooms.push(chatRoom);
    }
    state.displayingChatRoomId = chatRoom.chatRoomId;
  },
  addChatRoomOrderList(state, data) {
    const findChatRoom = helper.findByChatRoomId(state.tabChatRooms, data.chatRoomId);
    if (!findChatRoom.orderList) {
      findChatRoom.orderList = [];
    }
    if (findChatRoom.orderList.indexOf(data.orderId) < 0) {
      findChatRoom.orderList.unshift(data.orderId);
    }
    const newRoom = Object.assign({}, findChatRoom);
    if (findChatRoom !== undefined) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1);
      state.tabChatRooms.push(newRoom);
    }
  },
  changeChatRoomOrderList(state, data) {
    let findChatRoom = helper.findByChatRoomId(state.tabChatRooms, data.chatRoomId);
    findChatRoom.orderList = data.newOrderList;

    const newRoom = Object.assign({}, findChatRoom);
    if (findChatRoom !== undefined) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1);
      state.tabChatRooms.push(newRoom);
    }
  },
  deleteChatRoomOrderList(state, data) {
    const findChatRoom = helper.findByChatRoomId(state.tabChatRooms, data.chatRoomId);
    if (!findChatRoom.orderList) {
      return;
    }

    if (findChatRoom.orderList.indexOf(data.orderId) > -1) {
      const idx = findChatRoom.orderList.indexOf(data.orderId);
      findChatRoom.orderList.splice(idx, 1);
    }
    const newRoom = Object.assign({}, findChatRoom);
    if (findChatRoom !== undefined) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1);
      state.tabChatRooms.push(newRoom);
    }
  },
  deleteTabChatRoom(state, chatRoom) {
    const tab = helper.findByChatRoomId(state.tabChatRooms, chatRoom.chatRoomId);
    if (!helper.isObjectValid(tab)) {
      return;
    }
    state.tabChatRooms.splice(state.tabChatRooms.indexOf(tab), 1);
    if (state.tabChatRooms.length < 1) {
      state.markedChatRoom = undefined;
      state.displayingChatRoomId = -1;
    }
    if (tab.chatRoomId === state.displayingChatRoomId) {
      state.displayingChatRoomId = -1;
      // 마지막 탭 세팅
      const last = helper.getLastItem(state.tabChatRooms);
      if (helper.isObjectValid(last)) {
        eventBus.$emit('chat-room-tab-open', last.chatRoomId);
        eventBus.$emit(eventType.OPEN_CUSTOMER_INFO_TAP);
      }
    }
  },
  addWaitChatRoom(state, chatRoom) {
    if (helper.findByChatRoomId(state.waitChatRooms, chatRoom.chatRoomId) === undefined) {
      const newStatusRoom = Object.assign({}, chatRoom);
      newStatusRoom.status = 'WAITING';
      state.waitChatRooms.push(newStatusRoom);
      return state.waitChatRooms.sort((left, right) => right.createDate - left.createDate);
    }
  },
  removeWaitChatRoom(state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.waitChatRooms, chatRoom.chatRoomId);
    if (!helper.isObjectValid(findChatRoom)) {
      return;
    }
    const chatRoomIndex = state.waitChatRooms.indexOf(findChatRoom);
    state.waitChatRooms.splice(chatRoomIndex, 1);
  },
  addAssignChatRoom(state, chatRoom) {
    if (helper.findByChatRoomId(state.assignChatRooms, chatRoom.chatRoomId) === undefined) {
      const newStatusRoom = Object.assign({}, chatRoom);
      newStatusRoom.status = 'ASSIGN';
      state.assignChatRooms.push(newStatusRoom);
    }
  },
  removeAssignChatRoom(state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.assignChatRooms, chatRoom.chatRoomId);
    if (!helper.isObjectValid(findChatRoom)) {
      return;
    }
    const chatRoomIndex = state.assignChatRooms.indexOf(findChatRoom);
    state.assignChatRooms.splice(chatRoomIndex, 1);
  },
  addHoldChatRoom(state, chatRoom) {
    if (chatRoom && helper.findByChatRoomId(state.holdChatRooms, chatRoom.chatRoomId) === undefined) {
      const newStatusRoom = Object.assign({}, chatRoom);
      newStatusRoom.status = 'HOLD';
      state.holdChatRooms.push(newStatusRoom);
    }
  },
  removeHoldChatRoom(state, chatRoom) {
    if (chatRoom) {
      const findChatRoom = helper.findByChatRoomId(state.holdChatRooms, chatRoom.chatRoomId);
      if (!helper.isObjectValid(findChatRoom)) {
        return;
      }
      const chatRoomIndex = state.holdChatRooms.indexOf(findChatRoom);
      state.holdChatRooms.splice(chatRoomIndex, 1);
    }
  },
  addToActiveChatRoomList(state, chatRoom) {
    let newRoom;
    if (typeof chatRoom === 'string') {
      newRoom = Object.assign({}, JSON.parse(chatRoom));
    } else {
      newRoom = Object.assign({}, chatRoom);
    }
    if (chatRoom && helper.findByChatRoomId(state.activeChatRooms, newRoom.chatRoomId) === undefined) {
      newRoom.status = 'ACTIVE';
      state.activeChatRooms.push(newRoom);
    }
  },
  deleteToActiveChatRoomList(state, chatRoom) {
    if (chatRoom && chatRoom.chatRoomId) {
      const findChatRoom = helper.findByChatRoomId(state.activeChatRooms, chatRoom.chatRoomId);
      if (!helper.isObjectValid(findChatRoom)) {
        return;
      }
      const chatRoomIndex = state.activeChatRooms.indexOf(findChatRoom);
      state.activeChatRooms.splice(chatRoomIndex, 1);
    }
  },
  addSummaryChatRoom(state, chatRoom) {
    if (helper.findByChatRoomId(state.summaryChatRooms, chatRoom.chatRoomId) === undefined) {
      chatRoom.status = 'SUMMARY_WAITING';
      state.summaryChatRooms.push(chatRoom);
    }
  },
  removeSummaryChatRoom(state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.summaryChatRooms, chatRoom.chatRoomId);
    if (!helper.isObjectValid(findChatRoom)) {
      return;
    }
    const chatRoomIndex = state.summaryChatRooms.indexOf(findChatRoom);
    state.summaryChatRooms.splice(chatRoomIndex, 1);
  },
  addCompletedChatRoom(state, chatRoom) {
    if (helper.findByChatRoomId(state.completedChatRooms, chatRoom.chatRoomId) === undefined) {
      chatRoom.status = 'COMPLETED';
      state.completedChatRooms.push(chatRoom);
    }
  },
  addTransferChatRooms(state, chatRoom) {
    if (helper.findByChatRoomId(state.transferredChatRooms, chatRoom.chatRoomId) === undefined) {
      const newStatusRoom = Object.assign({}, chatRoom);
      newStatusRoom.status = 'TRANSFER';
      state.transferredChatRooms.push(newStatusRoom);
    }
  },
  removeTransferChatRooms(state, chatRoom) {
    if (chatRoom) {
      const findChatRoom = helper.findByChatRoomId(state.transferredChatRooms, chatRoom.chatRoomId);
      if (!helper.isObjectValid(findChatRoom)) {
        return;
      }
      const chatRoomIndex = state.transferredChatRooms.indexOf(findChatRoom);
      state.transferredChatRooms.splice(chatRoomIndex, 1);
    }
  },
  addAllChatRoom(state, chatRoom) {
    if (helper.findByChatRoomId(state.allChatRooms, chatRoom.chatRoomId) === undefined) {
      if (chatRoom.status === 'TAKE_OVER_ROOM') {
        chatRoom.status = 'TRANSFER';
      }
      if (chatRoom.isDelete) {
        delete chatRoom.isDelete;
        state.allChatRooms.splice(state.allChatRooms.length - 1, 1);
        state.allChatRooms.unshift(chatRoom);
      } else {
        state.allChatRooms.push(chatRoom);
      }
    }
  },
  removeAllChatRooms(state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.allChatRooms, chatRoom.chatRoomId);
    if (!helper.isObjectValid(findChatRoom)) {
      return;
    }
    const chatRoomIndex = state.allChatRooms.indexOf(findChatRoom);
    state.allChatRooms.splice(chatRoomIndex, 1);
    // delete state.lastMessages[chatRoom.chatRoomId] //왜 지우는걸까요?
  },
  clearAllChatRoom() {
    state.allChatRooms = [];
  },
  CLEAR_CHAT(state) {
    // 2022-04-13 리프레쉬 컴포넌트와 전체 상담 대기 카운트 가져오는 컴포넌트가 달라, 초기화 시 전체 상담 대기중 카운트는 초기화 하지 않도록 수정
    const tempWaitCount = state.waitCount;
    Object.assign(state, getDefaultState());
    state.waitCount = tempWaitCount;
  },
  markSelectedChatRoom(state, chatRoomId) {
    state.markedChatRoom = chatRoomId;
  },
  changeTagList(state, list) {
    state.tagList = list;
  },
  setAlarmedChatRoomId(state, chatRoomId) {
    state.alarmedChatRoomId = chatRoomId;
  },
  updateTabChatRoomList(state, { chatRoom, agentId }) {
    const chatRoomInTab = helper.findByChatRoomId(state.tabChatRooms, chatRoom.chatRoomId);

    // 탭 (상담방) 열려있는 경우에만 보여지는 상담방의 상태 변경
    const chatRoomIndex = state.tabChatRooms.indexOf(chatRoomInTab);
    if (chatRoomIndex > -1) {
      let updatedStatus = chatRoom.status;
      // 챗룸탭에서는 이관 상태를 'TRANSFER'로 갖고 있기 때문에 변환
      // 이관 후 채팅창 종료하지 않고 후기 등록하기 위해 SUMMARY_WAITING로 변환 (+이관 보낸사람과 이관 받은사람 구분 추가)
      if (updatedStatus === 'TAKE_OVER_ROOM') {
        if (chatRoom.agent.id === agentId) {
          updatedStatus = 'TRANSFER';
        } else {
          updatedStatus = 'SUMMARY_WAITING';
        }
      }

      // 전체 탭에서 열은 방은 status가 'ALL'이고 secondStatus에 실제 상담방 상태가 들어가므로 각각 처리
      if (state.tabChatRooms[chatRoomIndex].status === 'ALL') {
        state.tabChatRooms[chatRoomIndex].secondStatus = updatedStatus;
      } else {
        state.tabChatRooms[chatRoomIndex].status = updatedStatus;
      }
    }
  },
  changeIsSearchAllChatRoomMode(state, searchMode) {
    state.isSearchAllChatRoomMode = searchMode;
  },
  setWaitCount: (state, statuses) => {
    state.waitCount = statuses;
  },
  changeTyping(state, data) {
    // 어바웃펫 입력 감지 커스텀
    if (data.typing !== undefined && data.chatRoomId === state.displayingChatRoomId) {
      state.isTyping = data.typing;
    }
  },
  setIsFaqActive(state, data) {
    state.isFaqActive = data;
  },
  addArrFaqListItem(state, data) {
    let content = JSON.stringify({ text: JSON.parse(data.content).text.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/gi, '') });
    state.arrFaqList.unshift({ id: data.id, context: JSON.parse(content).text });
    if (state.arrFaqList.length > 9) {
      state.maxFaqList = true;
    } else {
      state.maxFaqList = false;
    }
  },
  deleteArrFaqListItem(state, index) {
    state.arrFaqList.splice(state.arrFaqList.indexOf(index), 1);
    if (state.arrFaqList.length > 9) {
      state.maxFaqList = true;
    } else {
      state.maxFaqList = false;
    }
  },
  deleteAllFaqListItem(state, data) {
    state.arrFaqList = [];
    state.maxFaqList = false;
  },
  setIsMsgContext(state, data) {
    state.isMsgContext = data;
  },
  updateWebChatCustomParameter(state, { chatRoomStatus, chatRoomId, webChatCustomParameters }) {
    /* 상담중인 상담방을 상태별로 업데이트 */
    let chatRoom;
    switch (chatRoomStatus) {
      case 'ACTIVE':
        chatRoom = helper.findByChatRoomId(state.activeChatRooms, chatRoomId);
        if (chatRoom) {
          const index = state.activeChatRooms.indexOf(chatRoom);
          state.activeChatRooms[index].webChatCustomParameters = webChatCustomParameters;
        }
        break;
      case 'TAKE_OVER_ROOM':
        chatRoom = helper.findByChatRoomId(state.transferredChatRooms, chatRoomId);
        if (chatRoom) {
          const index = state.transferredChatRooms.indexOf(chatRoom);
          state.transferredChatRooms[index].webChatCustomParameters = webChatCustomParameters;
        }
        break;
      case 'HOLD':
        chatRoom = helper.findByChatRoomId(state.holdChatRooms, chatRoomId);
        if (chatRoom) {
          const index = state.holdChatRooms.indexOf(chatRoom);
          state.holdChatRooms[index].webChatCustomParameters = webChatCustomParameters;
        }
        break;
      case 'ASSIGN':
        chatRoom = helper.findByChatRoomId(state.assignChatRooms, chatRoomId);
        if (chatRoom) {
          const index = state.assignChatRooms.indexOf(chatRoom);
          state.assignChatRooms[index].webChatCustomParameters = webChatCustomParameters;
        }
    }

    /* 전체탭 업데이트 */
    let allChatRoom = helper.findByChatRoomId(state.allChatRooms, chatRoomId);
    if (allChatRoom) {
      const index = state.allChatRooms.indexOf(allChatRoom);
      state.allChatRooms[index].webChatCustomParameters = webChatCustomParameters;
    }

    /* 중앙 탭 업데이트 */
    let tabChatRoom = helper.findByChatRoomId(state.tabChatRooms, chatRoomId);
    if (tabChatRoom) {
      const index = state.tabChatRooms.indexOf(tabChatRoom);
      state.tabChatRooms[index].webChatCustomParameters = webChatCustomParameters;
    }
  }
};

const actions = {
  updateChatRoomStatus({ commit }, { chatRoom, agentId }) {
    const $gtag = Vue.prototype.$gtag;
    const beforeStatus = chatRoom.beforeStatus;
    const currentStatus = chatRoom.status;
    let brandName = null;

    // 초기) 보류, 보류해제 (열려있는 탭만)
    // 다른 이관(TAKE_OVER_CHAT_ROOM 구독타입)과 같은 상태와
    // 달리 [보류, 보류 해제]의 경우에는 상태 변경 소켓 말고는 API 성공 이후 변경 또는 별도의 소켓 타입 없어서 여기서만 동작함
    // 추가) 보류, 보류해제 (열려있는 탭 구분없이 내가 보는창, 새 창 모두)
    // 추가) (내가 상태 변경한, 보고있지 않은) 새 창에서도 다른 상태로 변경되는 것 반영되게 하는 로직
    // 1. 상담중 : 대기중 -> 상담중 (기존에 새창 대응X, 추가), 할당 -> 상담중 (기존에 새창 대응X, 추가), 보류 -> 상담중 (이전 상태값 참조안해서 보류 해제에 대한 동작이 상담중으로 변경된 건에 대해서 전부 동작해서 이전 상태 보류 조건 추가함)
    // 2. 이관 (기존 TRANSFER -> TAKE_OVER_ROOM) : 상담중 -> 이관, 보류 -> 이관, 이관 -> 이관
    // 참고로 2. 이관 (기존 TRANSFER) 은 이관할 때 이전 상태가 보류이면, 상담중 상태로 변경되는 로직을 통해 보류해제가 되지...
    // 현재 기존 TRANSFER 상태 내 보류해제 로직을 통해서 보류해제 안됨 (물론 중간에 상담중으로 변경하는 로직이 추가되어서 변경된 플로우 일 수 있음)
    switch (currentStatus) {
      // 기존 로직 유지, beforeStatus 만 적용
      case 'HOLD':
        if (beforeStatus === 'ACTIVE') {
          // 상담중 -> 보류
          commit('deleteToActiveChatRoomList', chatRoom);
        } else if (beforeStatus === 'TAKE_OVER_ROOM') {
          // 이관 -> 보류
          commit('removeTransferChatRooms', chatRoom);
        }

        commit('addHoldChatRoom', chatRoom); // 보류에 추가
        brandName = chatRoom && chatRoom.brandName ? chatRoom.brandName : chatRoom.brand.name;
        $gtag.event(`보류`, {
          event_category: `보류 통계_${brandName}`,
          event_label: chatRoom.moduleChannel.channelName.code
        });
        break;
      case 'ACTIVE':
        // 기존 로직 유지 (보류 해제) + 대기중 -> 상담중 + 할당 -> 상당중 추가 + beforeStatus 적용
        if (beforeStatus === 'WAITING') {
          // 대기중 -> 상담중 변경 건 (현재 픽한 창 아니고 다른 새창의 경우 동작)
          // 이전의 대기중 건은 `REMOVE_WAIT_CHAT_ROOM` 을 통해서 대기큐, 대기탭 에서 제거됨
          commit('addToActiveChatRoomList', chatRoom);
        } else if (beforeStatus === 'ASSIGN') {
          // 할당 -> 상담중 변경 건 (현재 픽한 창 아니고 다른 새창의 경우 동작)
          // 이전의 할당 건은 `REMOVE_ASSIGN_CHAT_ROOM` 을 통해서 할당 에서 제거됨
          commit('addToActiveChatRoomList', chatRoom);
        } else if (beforeStatus === 'HOLD') {
          // 보류 -> 상담이관 (보류 해제 이후의 상담이관 되는 것처럼 동작되어서 ACTIVE 상태의 소켓이 한번 날라온다, 그 때 보류에서 제거됨)
          // 그 이후에 상담중에도 추가되지만 이후에 오는 TAKE_OVER_ROOM 에 의해서 다시 상담중에서도 제거됨
          commit('removeHoldChatRoom', chatRoom);
          commit('addToActiveChatRoomList', chatRoom);

          brandName = chatRoom && chatRoom.brandName ? chatRoom.brandName : chatRoom.brand.name;
          $gtag.event(`보류 해제`, {
            event_category: `보류 통계_${brandName}`,
            event_label: chatRoom.moduleChannel.channelName.code
          });
        }
        break;
      case 'TAKE_OVER_ROOM':
        // 기존(TRANSFER)에 있던 보류 -> 이관 처리 유지 + 상담중 -> 이관 + 이관 -> 이관 추가 + beforeStatus 적용
        // 이관 구독 타입 소켓에 중복 로직 있음 (해당 타입 소켓이 순서상 먼저 오기때문에 그쪽 로직이 먼저 동작함)
        // 그쪽에서는 탭 열려있는 경우에만 동작 그외에는 현재 로직탐
        if (beforeStatus === 'HOLD') {
          commit('removeHoldChatRoom', chatRoom);

          brandName = chatRoom && chatRoom.brandName ? chatRoom.brandName : chatRoom.brand.name;
          $gtag.event(`보류 해제`, {
            event_category: `보류 통계_${brandName}`,
            event_label: chatRoom.moduleChannel.channelName.code
          });
        } else if (beforeStatus === 'ACTIVE') {
          // 상담중 -> 상담이관 (처리 후 내가 보는 화면에선 후처리 상태로 변경됨) 변경 건 (현재 픽한 창 아니고 다른 새창의 경우 동작)
          commit('deleteToActiveChatRoomList', chatRoom);
        } else if (beforeStatus === 'TAKE_OVER_ROOM') {
          // 이관되어서 나에게 온 건에 대한 처리는 TAKE_OVER_ROOM 구독 이벤트에서 처리됨
          // 그러나 이관 보낸 쪽에서는 지우는 처리가 당장 이관시킨 창에서만 동작함 (해당 로직은 새창에서 동작)
          if (chatRoom && chatRoom.agent.id !== agentId) {
            commit('removeTransferChatRooms', chatRoom);
          }
        }
        break;
      case 'SUMMARY_WAITING':
        // CLOSE_CHAT_ROOM 에서 상담중 -> 후처리 상태 변경 동작안할경우 보완
        if (beforeStatus === 'ACTIVE') {
          commit('deleteToActiveChatRoomList', chatRoom);
        }
        break;
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/chat/index.js